import { ConfirmationModal, Size } from '@access-erp/ui-components';
import copy from 'copy-to-clipboard';
import { useEffect, useState } from 'react';

import { DetailContainer } from './DetailContainer';
import styles from './sales-order-payload.module.scss';
import { getCopyPayloadJson } from '@/components/common/EnquiriesScreen/utils/troubleshootingPanelHelpers';
import useGetSODetails, { SODetails } from '../../hooks/useGetSODetails';

import { SalesOrderWithId } from '@/utils/data-helpers/types';
import { notificationService } from '@/services/notification/notification.client';
import Spinner from '@/components/common/Spinner/Spinner';

interface SalesOrderModalProps {
  isVisible: boolean;
  handleClose: () => void;
  selectedRow: SalesOrderWithId;
  isBillingCyclesPath: boolean;
}

export function SalesOrderPayloadModal({
  isVisible,
  handleClose,
  selectedRow,
  isBillingCyclesPath,
}: SalesOrderModalProps) {
  const { getSODetails } = useGetSODetails();
  const [details, setDetails] = useState<SODetails>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (selectedRow?.salesOrderID) {
      setIsLoading(true);
      getSODetails(selectedRow.salesOrderID, isBillingCyclesPath).then((res) => {
        setDetails(res.soDetails);
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
      setDetails(undefined);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCopy = () => {
    const textToBeCopied = getCopyPayloadJson(details);

    if (textToBeCopied) {
      copy(textToBeCopied);
      notificationService.open({
        title: 'Sales Order Payload text copy',
        text: 'The text has been copied successfully',
        type: 'success',
      });
    }
  };

  return (
    <ConfirmationModal
      open={isVisible}
      onClose={handleClose}
      title="Sales Order Payload"
      size={Size.Medium}
      confirmButtonText="Copy"
      onConfirm={handleCopy}
    >
      <div className={styles['details-list']}>
        {isLoading ? (
          <div className={styles['spinner-container']}>
            <Spinner />
          </div>
        ) : details ? (
          <DetailContainer isLoading={false} details={details} />
        ) : (
          <div className={styles['no-data']}>
            No payload data available
          </div>
        )}
      </div>
    </ConfirmationModal>
  );
}
